import { shipmentAffProductsByOrderValidate } from '../../application/dtos/shipment_aff_products_by_order_validate';

export class ShipmentAffProductsByOrderEntity {
    constructor({ products }){
        this.products = products;
    }

    isValid() {
        return shipmentAffProductsByOrderValidate(this);
    }
}